<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <pre v-on="on">{{shortValue}}</pre>
        </template>
        <pre>{{value}}</pre>
    </v-tooltip>
</template>

<script>
	export default {
		name: "PreShortener",
		props: ['value'],
		computed: {
			shortValue() {
				if (this.value.length < 10) {
					return this.value;
				} else {
					let l = this.value.length;
					return this.value.slice(0, 4) + "…" + this.value.slice(l - 4, l)
				}
			}
		}
	}
</script>

<style scoped>

</style>
